let appConfig = {
    apiUrl: '',
};
export function setAppConfig(newAppConfig) {
    appConfig = newAppConfig;
}
export function getAppConfig() {
    return appConfig;
}
